import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('stripe'),
  titleToNamespace: true,
  experimental: false,
  hasConnectionStatus: false,
  avatarPath: avatars.stripe,
  logoPath: logos.stripe
});
